export class SagaErrorHandler {
  static catchError(error, { sagaStack }) {
    //TO DO send error
  }
}
